export default __webpack_public_path__ + "static/media/minus-resale.8b466db4.svg";